export interface JobListing {
  id?: number;
  job_id?: number;
  job_listing_items: JobListingItem[];
  publisher_is_draft: boolean;
  publisher_is_published: boolean;
  publisher_modified_at?: string;
  publisher_published_at?: number;
  created_at?: string;
  updated_at?: string;
  global_background_rgba: string;
  global_text_style: string;
  global_divider_status: boolean;
  publisher_linked?: number;
}

export interface JobListingItem {
  id?: number;
  job_listing_id?: number;
  blog_listing_id?: number;
  career_page_id?: number;
  background_image_media_id?: number;
  image_media_id?: number;
  background_image_url?: string;
  background_image_thumbnail?: string;
  image_url?: string;
  image_thumbnail?: string;
  created_at?: string;
  updated_at?: string;
  type: number;
  position: number;
  background_rgba?: string;
  font_rgba?: string;
  title_rich?: string;
  title?: string;
  subtitle?: string;
  subtitle_rich?: string;
  youtube_video_id?: string;
  vimeo_video_id?: string;
  autoplay?: false;
  full_width?: false;
  free_text_rich?: string;
  free_text_image_type?: string;
  job_listing?: number;
  career_page?: number;
  blog_listing?: number;
  image_media?: number;
  background_image_media?: number;
}

export enum LISTING_ITEM_TYPE {
  LISTING_ITEM_HEADER = 0,
  LISTING_ITEM_ABOUT_JOB = 1,
  LISTING_ITEM_IMAGE = 2,
  LISTING_ITEM_VIDEO = 3,
  LISTING_ITEM_FREE_TEXT = 4,
  LISTING_ITEM_FREE_TEXT_IMAGE = 5,
  LISTING_ITEM_FOOTER = 6,
  LISTING_ITEM_JOBS = 7,
  LISTING_ITEM_ABOUT_OFFICE = 8,
}

export const EMPTY_LISTING: JobListing = {
  job_listing_items: [
    {
      background_image_url: '',
      background_image_thumbnail: '',
      image_url: '',
      image_thumbnail: '',
      type: LISTING_ITEM_TYPE.LISTING_ITEM_HEADER,
      position: 0,
      background_rgba: '#FFFFFF00',
      font_rgba: '#000000FF',
      title_rich: '',
      title: '',
      subtitle: '',
      subtitle_rich: '',
      youtube_video_id: null,
      vimeo_video_id: null,
      autoplay: false,
      full_width: false,
      free_text_rich: '',
      free_text_image_type: 'text_on_the_left',
      career_page: null,
      blog_listing: null,
      image_media: null,
      background_image_media: null,
    },
    {
      background_image_url: '',
      background_image_thumbnail: '',
      image_url: '',
      image_thumbnail: '',
      type: LISTING_ITEM_TYPE.LISTING_ITEM_ABOUT_JOB,
      position: 1,
      background_rgba: '#FFFFFF00',
      font_rgba: '#000000FF',
      title_rich: '',
      title: '',
      subtitle: '',
      subtitle_rich: '',
      youtube_video_id: null,
      vimeo_video_id: null,
      autoplay: false,
      full_width: false,
      free_text_rich: '',
      free_text_image_type: 'text_on_the_left',
      career_page: null,
      blog_listing: null,
      image_media: null,
      background_image_media: null,
    },
    {
      background_image_url: '',
      background_image_thumbnail: '',
      image_url: '',
      image_thumbnail: '',
      type: LISTING_ITEM_TYPE.LISTING_ITEM_ABOUT_OFFICE,
      position: 2,
      background_rgba: '#FFFFFF00',
      font_rgba: '#000000FF',
      title_rich: '',
      title: '',
      subtitle: '',
      subtitle_rich: '',
      youtube_video_id: null,
      vimeo_video_id: null,
      autoplay: false,
      full_width: false,
      free_text_rich: '',
      free_text_image_type: 'text_on_the_left',
      career_page: null,
      blog_listing: null,
      background_image_media: null,
    },
    {
      background_image_url: '',
      background_image_thumbnail: '',
      image_url: '',
      image_thumbnail: '',
      type: LISTING_ITEM_TYPE.LISTING_ITEM_FOOTER,
      position: 3,
      background_rgba: '#FFFFFF00',
      font_rgba: '#000000FF',
      title_rich: '',
      title: '',
      subtitle: '',
      subtitle_rich: '',
      youtube_video_id: null,
      vimeo_video_id: null,
      autoplay: false,
      full_width: false,
      free_text_rich: '',
      free_text_image_type: 'text_on_the_left',
      career_page: null,
      blog_listing: null,
      image_media: null,
      background_image_media: null,
    },
  ],
  global_background_rgba: '#FFFFFFFF',
  global_text_style: 'sans',
  global_divider_status: false,
  publisher_is_draft: true,
  publisher_is_published: false,
};

export const LISTING_ITEM_HEADER = {
  type: LISTING_ITEM_TYPE.LISTING_ITEM_HEADER,
  subtitleRich: '',
  titleRich: '',
  title: '',
  backgroundImage: '',
  backgroundImageUrl: '',
  backgroundImageThumbnail: '',
  backgroundImageMediaId: '',
};

export const LISTING_ITEM_ABOUT_JOB = {
  type: LISTING_ITEM_TYPE.LISTING_ITEM_ABOUT_JOB,
  subtitleRich: '',
  titleRich: '',
  title: '',
  image: '',
  imageUrl: '',
  imageThumbnail: '',
  imageMediaId: '',
};

export const LISTING_ITEM_IMAGE = {
  type: LISTING_ITEM_TYPE.LISTING_ITEM_IMAGE,
  title: '',
  titleRich: '',
  image: '',
  imageUrl: '',
  imageThumbnail: '',
  imageMediaId: '',
};

export const LISTING_ITEM_VIDEO = {
  type: LISTING_ITEM_TYPE.LISTING_ITEM_VIDEO,
  youtubeVideoId: '',
  vimeoVideoId: '',
  titleRich: '',
  title: '',
};

export const LISTING_ITEM_FREE_TEXT = {
  type: LISTING_ITEM_TYPE.LISTING_ITEM_FREE_TEXT,
  freeTextRich: '',
  freeText: '',
};

export const LISTING_ITEM_FREE_TEXT_IMAGE = {
  type: LISTING_ITEM_TYPE.LISTING_ITEM_FREE_TEXT_IMAGE,
  subtitleRich: '',
  titleRich: '',
  title: '',
  image: '',
  imageUrl: '',
  imageThumbnail: '',
  imageMediaId: '',
  freeTextType: '',
  freeTextRich: '',
};

export const LISTING_ITEM_FOOTER = {
  type: LISTING_ITEM_TYPE.LISTING_ITEM_FOOTER,
};

export const LISTING_ITEM_JOBS = {
  type: LISTING_ITEM_TYPE.LISTING_ITEM_JOBS,
  titleRich: '',
  title: '',
};

export const LISTING_ITEM_ABOUT_OFFICE = {
  type: LISTING_ITEM_TYPE.LISTING_ITEM_ABOUT_OFFICE,
  titleRich: '',
  title: '',
  subtitleRich: '',
};
